import React from "react";
import {
  useMoodleGame,
  useStartMoodleGame,
} from "../../../features/Moodle/MoodleGame";
import { Modal } from "antd";
import { ErrorText } from "../../../shared/ui";
import { QuizModuleWidget } from "../../QuizModuleWidget";
import { TheoryModuleWidget } from "../../TheoryModuleWidget";

type Props = {
  courseId: string;
};

const MoodleGameWidget = (props: Props) => {
  const { setQuestions, setAttempt, setIsQuestionModalOpened } = useMoodleGame(
    {}
  );

  const { isOpen, isGamePassed, error, game, handleOk, handleCansel } =
    useStartMoodleGame({
      courseId: props.courseId,
    });

  return (
    <Modal
      title="Игра"
      open={isOpen}
      onOk={handleOk}
      maskClosable={false}
      okText={isGamePassed ? "Начать снова" : "Продолжить"}
      cancelText="Закрыть"
      onCancel={handleCansel}
    >
      <div>
        {error.length > 0 && <ErrorText error={error} />}
        <div>Текущий этап: {game?.course_stage}</div>
        <div>Всего этапов: {game?.course_length}</div>
        {game?.module &&
          (game?.module?.type == "quiz" ? (
            <QuizModuleWidget module={game.module} />
          ) : (
            <TheoryModuleWidget module={game.module} />
          ))}
      </div>
    </Modal>
  );
};

export default MoodleGameWidget;
